import * as React from 'react';
import { GlobalDataFilter } from '../HotelsLeftSide';
import { HotelSearchResultWithUrlReqKeyMainPanel, FilterSelected, CurrenSelectedFilter } from '../HotelSearchResultWithUrlReqKeyMainPanel';
import { HotelBedData } from 'src/shared';
import { bandingkanArray, kuraingArray } from './bandingkanArray';

export function isiMobileFilter(showMobileFilter: boolean, filters: GlobalDataFilter, getAvailabilityDetailFiltered: (hotelCodes: number[], externalFilter: HotelBedData.ExternalFilter) => any, panel: HotelSearchResultWithUrlReqKeyMainPanel, filterSelected: FilterSelected, currenSelectedFilter: CurrenSelectedFilter) {
    let sty: any = { display: "none" };
    let retbudget: any[] = [];
    let retTopArea: any[] = [];
    let retstar: any[] = [];
    let retType: any[] = [];
    let retFas: any[] = [];
    let retSpecial: any[] = [];
    if (showMobileFilter) {
        sty = {};
        for (let fil of filters.PriceRage) {
            let style: any = { background: '#e5d2ff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
            let icon = <i className="ti-layout-width-full" />;
            let curSelect = filterSelected; // new code
            let current: boolean = false;   // new code
            if (curSelect.PriceRage.indexOf(fil.description) > -1) {
                style = { background: '#ceabff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
                icon = <i className="ti-check-box" />;
                current = true;
            }
            retbudget.push(
                <li style={{ marginLeft: '-40px' }}>
                    <a
                        style={style}
                        onClick={
                            () => {
                                let desFilter = curSelect.PriceRage; // new code 
                                console.log('desFilter', desFilter);
                                let htCodes = fil.hotelCodes;
                                let htC: number[] = [];
                                for (let f of Object.keys(currenSelectedFilter)) {
                                    if (f !== "PriceRage") {
                                        htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                    }
                                }
                                // let curSelect = filterSelected;  di hapus
                                if (!current) {
                                    htCodes.push(...currenSelectedFilter.PriceRage);
                                    currenSelectedFilter.PriceRage = htCodes;
                                    htCodes = bandingkanArray(htCodes, htC);
                                    // desFilter.push(fil.description);
                                    desFilter += fil.description;
                                    console.log("desFilter", desFilter);
                                    curSelect.PriceRage = desFilter;
                                } else {
                                    let x = desFilter;
                                    let y = fil.description;
                                    let b = x.replace(y, '');
                                    curSelect.PriceRage = b;
                                    let n = currenSelectedFilter.PriceRage;
                                    console.log("htCodes", n);
                                    let m = fil.hotelCodes;
                                    console.log("htCodes", m);
                                    let o = kuraingArray(n, m);
                                    console.log("htCodes", o);
                                    currenSelectedFilter.PriceRage = o;
                                    htCodes = bandingkanArray(o, htC);
                                }
                                panel.setState({ budget: fil.description, page: 0, showMobileFilter: false, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                            }
                        }
                    >{icon} {fil.description}
                    </a>
                </li>
            );
        }
        let selectedTopArea: string[] = ['Kuta/ Legian', 'Nusa Dua-Tanjung Benoa', 'Sanur', 'Ubud', 'Jimbaran', 'Seminyak', 'Kerobokan', 'Lembongan Island', 'Uluwatu', 'Canggu'];
        for (let fil of filters.DestinationZone) {
            let style: any = { background: '#e5d2ff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
            let icon = <i className="ti-layout-width-full" />;
            let curSelect = filterSelected; // new code
            let current: boolean = false;   // new code
            if (curSelect.DestinationZone.indexOf(fil.description) > -1) {
                style = { background: '#ceabff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
                icon = <i className="ti-check-box" />;
                current = true;
            }
            if (selectedTopArea.indexOf(fil.description) > -1) {
                retTopArea.push(
                    <li style={{ marginLeft: '-40px' }}>
                        <a
                            style={style}
                            onClick={
                                () => {
                                    let desFilter = curSelect.DestinationZone;
                                    let htCodes = fil.hotelCodes;
                                    let htC: number[] = [];
                                    for (let f of Object.keys(currenSelectedFilter)) {
                                        if (f !== "DestinationZone") {
                                            htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                        }
                                    }
                                    if (!current) {
                                        htCodes.push(...currenSelectedFilter.DestinationZone);
                                        currenSelectedFilter.DestinationZone = htCodes;
                                        htCodes = bandingkanArray(htCodes, htC);
                                        // desFilter.push(fil.description);
                                        desFilter += fil.description;
                                        curSelect.DestinationZone = desFilter;
                                    } else {
                                        let x = desFilter;
                                        let y = fil.description;
                                        let b = x.replace(y, '');
                                        curSelect.DestinationZone = b;
                                        let n = currenSelectedFilter.DestinationZone;
                                        console.log("htCodes", n);
                                        let m = fil.hotelCodes;
                                        console.log("htCodes", m);
                                        let o = kuraingArray(n, m);
                                        console.log("htCodes", o);
                                        currenSelectedFilter.DestinationZone = o;
                                        htCodes = bandingkanArray(o, htC);
                                    }
                                    panel.setState({ topArea: fil.description, page: 0, showMobileFilter: false, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                                }
                            }
                        > {icon} {fil.description}
                        </a>
                    </li>
                );
            }
        }
        for (let fil of filters.Category) {
            let style: any = { background: '#e5d2ff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
            let icon = <i className="ti-layout-width-full" />;
            let curSelect = filterSelected; // new code
            let current: boolean = false;   // new code
            if (curSelect.Category.indexOf(fil.description) > -1) {
                style = { background: '#ceabff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
                icon = <i className="ti-check-box" />;
                current = true;
            }
            retstar.push(
                <li style={{ marginLeft: '-40px' }}>
                    <a
                        style={style}
                        onClick={
                            () => {
                                let desFilter = curSelect.Category; // new code 
                                let htCodes = fil.hotelCodes;
                                let htC: number[] = [];
                                for (let f of Object.keys(currenSelectedFilter)) {
                                    if (f !== "Category") {
                                        htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                    }
                                }
                                // let curSelect = filterSelected;  di hapus
                                if (!current) {
                                    htCodes.push(...currenSelectedFilter.Category);
                                    currenSelectedFilter.Category = htCodes;
                                    htCodes = bandingkanArray(htCodes, htC);
                                    // desFilter.push(fil.description);
                                    desFilter += fil.description;
                                    curSelect.Category = desFilter;
                                } else {
                                    let x = desFilter;
                                    let y = fil.description;
                                    let b = x.replace(y, '');
                                    curSelect.Category = b;
                                    let n = currenSelectedFilter.Category;
                                    console.log("htCodes", n);
                                    let m = fil.hotelCodes;
                                    console.log("htCodes", m);
                                    let o = kuraingArray(n, m);
                                    console.log("htCodes", o);
                                    currenSelectedFilter.Category = o;
                                    htCodes = bandingkanArray(o, htC);
                                }
                                panel.setState({ star: fil.description, page: 0, showMobileFilter: false, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                            }
                        }
                    > {icon} {fil.description}
                    </a>
                </li>
            );
        }

        let selectedretType: string[] = ['Business hotels ', 'Beach hotels', 'Family hotels ', 'Hotels with spa'];
        for (let fil of filters.Segment) {
            let style: any = { background: '#e5d2ff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
            let icon = <i className="ti-layout-width-full" />;
            let curSelect = filterSelected; // new code
            let current: boolean = false;   // new code
            if (curSelect.Segment.indexOf(fil.description) > -1) {
                style = { background: '#ceabff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
                icon = <i className="ti-check-box" />;
                current = true;
            }
            if (selectedretType.indexOf(fil.description) > -1) {
                retType.push(
                    <li style={{ marginLeft: '-40px' }}>
                        <a
                            style={style}
                            onClick={
                                () => {
                                    let desFilter = curSelect.Segment; // new code 
                                    let htCodes = fil.hotelCodes;
                                    let htC: number[] = [];
                                    for (let f of Object.keys(currenSelectedFilter)) {
                                        if (f !== "Segment") {
                                            htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                        }
                                    }
                                    // let curSelect = filterSelected;  di hapus
                                    if (!current) {
                                        htCodes.push(...currenSelectedFilter.Segment);
                                        currenSelectedFilter.Segment = htCodes;
                                        htCodes = bandingkanArray(htCodes, htC);
                                        // desFilter.push(fil.description);
                                        desFilter += fil.description;
                                        curSelect.Segment = desFilter;
                                    } else {
                                        let x = desFilter;
                                        let y = fil.description;
                                        let b = x.replace(y, '');
                                        curSelect.Segment = b;
                                        let n = currenSelectedFilter.Segment;
                                        console.log("htCodes", n);
                                        let m = fil.hotelCodes;
                                        console.log("htCodes", m);
                                        let o = kuraingArray(n, m);
                                        console.log("htCodes", o);
                                        currenSelectedFilter.Segment = o;
                                        htCodes = bandingkanArray(o, htC);
                                    }
                                    panel.setState({ type: fil.description, page: 0, showMobileFilter: false, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                                }
                            }
                        > {icon} {fil.description}
                        </a>
                    </li>
                );
            }

        }

        let selectedFas: string[] = ['Swim-up bar', 'Kids’ club', 'Private Pool', 'Meeting room'];
        for (let fil of filters.Facilities) {
            let style: any = { background: '#e5d2ff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
            let icon = <i className="ti-layout-width-full" />;
            let curSelect = filterSelected; // new code
            let current: boolean = false;   // new code
            if (curSelect.Facilities.indexOf(fil.description) > -1) {
                style = { background: '#ceabff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
                icon = <i className="ti-check-box" />;
                current = true;
            }
            if (selectedFas.indexOf(fil.description) > -1) {
                retFas.push(
                    <li style={{ marginLeft: '-40px' }}>
                        <a
                            style={style}
                            onClick={
                                () => {
                                    let desFilter = curSelect.Facilities; // new code 
                                    let htCodes = fil.hotelCodes;
                                    let htC: number[] = [];
                                    for (let f of Object.keys(currenSelectedFilter)) {
                                        if (f !== "Facilities") {
                                            htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                        }
                                    }
                                    // let curSelect = filterSelected;  di hapus
                                    if (!current) {
                                        htCodes.push(...currenSelectedFilter.Facilities);
                                        currenSelectedFilter.Facilities = htCodes;
                                        htCodes = bandingkanArray(htCodes, htC);
                                        // desFilter.push(fil.description);
                                        desFilter += fil.description;
                                        curSelect.Facilities = desFilter;
                                    } else {
                                        let x = desFilter;
                                        let y = fil.description;
                                        let b = x.replace(y, '');
                                        curSelect.Facilities = b;
                                        let n = currenSelectedFilter.Facilities;
                                        console.log("htCodes", n);
                                        let m = fil.hotelCodes;
                                        console.log("htCodes", m);
                                        let o = kuraingArray(n, m);
                                        console.log("htCodes", o);
                                        currenSelectedFilter.Facilities = o;
                                        htCodes = bandingkanArray(o, htC);
                                    }
                                    panel.setState({ facilities: fil.description, page: 0, showMobileFilter: false, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                                }
                            }
                        > {icon} {fil.description}
                        </a>
                    </li>
                );
            }

        }

        let selectedSpesial: string[] = ['Last minute discount', 'Special Offer', 'Long Stay discount', 'Early Booking discount'];
        for (let fil of filters.Special) {
            let style: any = { background: '#e5d2ff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
            let icon = <i className="ti-layout-width-full" />;
            let curSelect = filterSelected; // new code
            let current: boolean = false;   // new code
            if (curSelect.Special.indexOf(fil.description) > -1) {
                style = { background: '#ceabff', padding: '8px 10px', display: 'block', borderBottom: '1px solid #d0c5ff' };
                icon = <i className="ti-check-box" />;
                current = true;
            }
            if (selectedSpesial.indexOf(fil.description) > -1) {
                retSpecial.push(
                    <li style={{ marginLeft: '-40px' }}>
                        <a
                            style={style}
                            onClick={
                                () => {
                                    let desFilter = curSelect.Special; // new code 
                                    let htCodes = fil.hotelCodes;
                                    let htC: number[] = [];
                                    for (let f of Object.keys(currenSelectedFilter)) {
                                        if (f !== "Special") {
                                            htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                        }
                                    }
                                    // let curSelect = filterSelected;  di hapus
                                    if (!current) {
                                        htCodes.push(...currenSelectedFilter.Special);
                                        currenSelectedFilter.Special = htCodes;
                                        htCodes = bandingkanArray(htCodes, htC);
                                        // desFilter.push(fil.description);
                                        desFilter += fil.description;
                                        curSelect.Special = desFilter;
                                    } else {
                                        let x = desFilter;
                                        let y = fil.description;
                                        let b = x.replace(y, '');
                                        curSelect.Special = b;
                                        let n = currenSelectedFilter.Special;
                                        console.log("htCodes", n);
                                        let m = fil.hotelCodes;
                                        console.log("htCodes", m);
                                        let o = kuraingArray(n, m);
                                        console.log("htCodes", o);
                                        currenSelectedFilter.Special = o;
                                        htCodes = bandingkanArray(o, htC);
                                    }
                                    panel.setState({ special: fil.description, page: 0, showMobileFilter: false, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                                }
                            }
                        > {icon} {fil.description}
                        </a>
                    </li>
                );
            }

        }
    }
    // console.log("retbudget", retbudget);
    // console.log("retTopArea", retTopArea);
    // console.log("retstar", retstar);
    // console.log("retType", retType);
    // console.log("retFas", retFas);
    // console.log("retSpecial", retSpecial);
    return (
        <div className="panel-group accordion" id="accordion" style={sty}>
            <div className="panel panel-white">
                <div className="panel-heading">
                    <h5 className="panel-title">
                        <a style={{ background: '#a185ef', fontSize: 14, color: '#FFF' }} className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true">
                            <i className="icon-arrow" /> Budget
                        </a>
                    </h5>
                </div>
                <div id="collapseOne" className="panel-collapse collapse in" aria-expanded="true">
                    <div className="panel-body" style={{ padding: 0 }}>
                        <ul style={{ listStyleType: 'none', marginBottom: 0 }}>
                            {retbudget}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="panel panel-white">
                <div className="panel-heading">
                    <h5 className="panel-title">
                        <a style={{ background: '#a185ef', fontSize: 14, color: '#FFF' }} className="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsespesial" aria-expanded="false">
                            <i className="icon-arrow" /> Special
                        </a>
                    </h5>
                </div>
                <div id="collapsespesial" className="panel-collapse collapse" aria-expanded="false" style={{ height: 0 }}>
                    <div className="panel-body" style={{ padding: 0 }}>
                        <ul style={{ listStyleType: 'none', marginBottom: 0 }}>{retSpecial}</ul>
                    </div>
                </div>
            </div>
            <div className="panel panel-white">
                <div className="panel-heading">
                    <h5 className="panel-title">
                        <a style={{ background: '#a185ef', fontSize: 14, color: '#FFF' }} className="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false">
                            <i className="icon-arrow" /> Star Hotel
                        </a>
                    </h5>
                </div>
                <div id="collapseThree" className="panel-collapse collapse" aria-expanded="false" style={{ height: 0 }}>
                    <div className="panel-body" style={{ padding: 0 }}>
                        <ul style={{ listStyleType: 'none', marginBottom: 0 }}>{retstar}</ul>
                    </div>
                </div>
            </div>
            <div className="panel panel-white">
                <div className="panel-heading">
                    <h5 className="panel-title">
                        <a style={{ background: '#a185ef', fontSize: 14, color: '#FFF' }} className="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false">
                            <i className="icon-arrow" /> Top Area
                        </a>
                    </h5>
                </div>
                <div id="collapseTwo" className="panel-collapse collapse" aria-expanded="false" style={{ height: 0 }}>
                    <div className="panel-body" style={{ padding: 0 }}>
                        <ul style={{ listStyleType: 'none', marginBottom: 0 }}>{retTopArea}</ul>
                    </div>
                </div>
            </div>

            <div className="panel panel-white">
                <div className="panel-heading">
                    <h5 className="panel-title">
                        <a style={{ background: '#a185ef', fontSize: 14, color: '#FFF' }} className="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsefas" aria-expanded="false">
                            <i className="icon-arrow" /> Facilities
                        </a>
                    </h5>
                </div>
                <div id="collapsefas" className="panel-collapse collapse" aria-expanded="false" style={{ height: 0 }}>
                    <div className="panel-body" style={{ padding: 0 }}>
                        <ul style={{ listStyleType: 'none', marginBottom: 0 }}>{retFas}</ul>
                    </div>
                </div>
            </div>

            <div className="panel panel-white">
                <div className="panel-heading">
                    <h5 className="panel-title">
                        <a style={{ background: '#a185ef', fontSize: 14, color: '#FFF' }} className="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapsetyp" aria-expanded="false">
                            <i className="icon-arrow" /> Type of Hotel
                        </a>
                    </h5>
                </div>
                <div id="collapsetyp" className="panel-collapse collapse" aria-expanded="false" style={{ height: 0 }}>
                    <div className="panel-body" style={{ padding: 0 }}>
                        <ul style={{ listStyleType: 'none', marginBottom: 0 }}>{retType}</ul>
                    </div>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/hotels/hotel-top-filter/isiMobileFilter.tsx